let recentItems = [];
let folders = [];
let foldersOpen = true;
let recentsOpen = true;
let expandedFolderId = null;

const itemKey = (item) => `${item?.type}:${item?.id}`;

export const getCachedRecentItems = () => recentItems;

export const setCachedRecentItems = (items, { take, fromFetch = false } = {}) => {
  if (!Array.isArray(items)) return recentItems;

  const fetchedKeys = new Set(items.map(itemKey));
  const keepCachedExtras = recentItems.filter((item) => {
    if (fetchedKeys.has(itemKey(item))) {
      return false;
    }
    const age = Date.now() - new Date(item.updatedAt).getTime();
    return Number.isFinite(age) && age >= 0 && age < 5 * 60 * 1000;
  });

  if (
    fromFetch ||
    (typeof take === 'number' && take < recentItems.length && items.length < recentItems.length)
  ) {
    recentItems = [...items, ...keepCachedExtras];
    return recentItems;
  }

  recentItems = items;
  return recentItems;
};

export const getCachedFolders = () => folders;

export const setCachedFolders = (items) => {
  if (Array.isArray(items)) {
    folders = items;
  }
  return folders;
};

export const getCachedFoldersOpen = () => foldersOpen;

export const setCachedFoldersOpen = (value) => {
  foldersOpen = Boolean(value);
  return foldersOpen;
};

export const getCachedRecentsOpen = () => recentsOpen;

export const setCachedRecentsOpen = (value) => {
  recentsOpen = Boolean(value);
  return recentsOpen;
};

export const getCachedExpandedFolderId = () => expandedFolderId;

export const setCachedExpandedFolderId = (value) => {
  expandedFolderId = value || null;
  return expandedFolderId;
};
